import { FormResult } from '../types';

export type FormResultReport = {
  rows: FormResult[];
  pageInfo: {
    totalEntries: number;
  };
};

export type FormColumn = {
  isRequired: boolean;
  isDefault: boolean;
  isSortable: boolean;
  isFile: boolean;
  label: string;
  name: string;
};

export type Filter = {
  field: string;
  label: string;
  type: 'multi-select';
  options: {
    label: string;
    value: string;
  }[];
};

export type ReportExport = {
  fileName: string;
  fileExtension: string;
  fileData: string;
};

export type Field = {
  label: string;
  type: 'date' | 'text' | 'select' | 'numeric';
};

export enum ModalType {
  ROSTER,
  EMAIL,
  OFFER,
  REMOVE_WAITLIST,
  DELETE_FORM_RESULT,
  POST_REG_EDIT,
  POST_REG_EDIT_LOGS,
  EXPORT,
}

export type ParticipantListModal = {
  isOpen: boolean;
  modalType: ModalType;
};
